<script setup lang="ts">
    import EchoButton from '../components/EchoButton.vue';
    import ScheduleCoachingList from '../components/coaching/ScheduleCoachingList.vue';
    import SettingsPageLayout from '../components/settings/SettingsPageLayout.vue';
    import { __ } from '../stores/expressions';
    import { useScheduleCoaching } from '../stores/scheduleCoaching';
    import { usePermissions } from '@/js/composables/usePermissions';
    import { PermissionArea, QualityAssuranceModulePermissionFlag } from '@/js/consts/permissions';
    import { PlusIcon } from '@lucide/vue';

    const { hasPermission } = usePermissions();

    const canScheduleCoaching = hasPermission(
        PermissionArea.QualityAssuranceModule,
        QualityAssuranceModulePermissionFlag.ScheduleCoaching
    );

    const scheduleCoaching = useScheduleCoaching();
</script>
<template>
    <SettingsPageLayout fill-table>
        <template #header>
            <h1 class="heading-lg-light">{{ __('settings-schedule-forms') }}</h1>
            <p class="text-body">
                {{ __('schedule-coaching-forms-subtititle') }}
            </p>
        </template>
        <template #topbar>
            <EchoButton v-if="canScheduleCoaching" @click="scheduleCoaching.openScheduleCoaching">
                {{ __('schedule-coaching-forms-new') }}
                <template #icon-right><PlusIcon /></template>
            </EchoButton>
        </template>
        <template #content>
            <ScheduleCoachingList />
        </template>
    </SettingsPageLayout>
</template>
